import React from 'react';
import 'react-app-polyfill/ie11';
import ReactDOM from 'react-dom';
import 'url-polyfill';
import App from './App';
// import './libs/bootstrap.min.css'
import './index.css';
import './libs/adapter-latest.js';
import './libs/bootstrap.min.css';
// import './libs/jquery-autogrow-textarea.js';
import './libs/RecordRTC.min';
import * as serviceWorker from './serviceWorker';
import './style.css';

// import './libs/jquery-1.11.1.min';
window.$ = window.jQuery = require("jquery");
require('./libs/jquery-autogrow-textarea');
(function (w) {
    w.URLSearchParams = w.URLSearchParams || function (searchString) {
        var self = this;
        self.searchString = searchString;
        self.get = function (name) {
            var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(self.searchString);
            if (results == null) {
                return null;
            } else {
                return decodeURI(results[1]) || 0;
            }
        };
    }

})(window)

var url = new URL(window.location.href);

if (typeof url.searchParams == "undefined") {
    url.searchParams = new URLSearchParams(url.search);
}
var lang = url.searchParams.get("lang") ? url.searchParams.get("lang") : 'en';

// fix for redirect
if (lang === 'undefined') {
    lang = 'en';
}

// band-aid for chinese
if (lang === 'cn') {
    lang = 'zh-cn';
}
if (lang === 'jp') {
    lang = 'ja';
}

var text = true;
if (url.searchParams.get("text") === "0") {
    text = false;
}

var microphone = false;
if (url.searchParams.get("microphone") === "1") {
    microphone = true;
}

var header = false;
if (url.searchParams.get("header") === "1") {
    header = true;
}

var checkTimeout = false;
if (url.searchParams.get("checkTimeout") === "1") {
    checkTimeout = true;
}
var wizard = false;
if (["1", "2", "3"].includes(url.searchParams.get("wizard"))) {
    wizard = url.searchParams.get("wizard");
}

var wizard_open = false;
if (url.searchParams.get("wizard_open") === "1") {
    wizard_open = true;
}


var timeoutInterval = 180;
if (url.searchParams.get("timeoutInterval")) {
    timeoutInterval = parseInt(url.searchParams.get("timeoutInterval"));
}

var countryCode = null;
if (url.searchParams.get("country_code")) {
    countryCode = url.searchParams.get("country_code");
}

ReactDOM.render(<App
    locale={lang}
    header={header}
    microphone={microphone}
    text={text}
    wizard={wizard}
    wizard_open={wizard_open}
    timeoutInterval={timeoutInterval}
    checkTimeout={checkTimeout}
    countryCode={countryCode}

/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
